import { GUID } from "app/brightserve/brightserve.module";
import { User } from "app/shared/user";

export class Doctor extends User {
    Email: string;
    PhoneNumber: string;

    constructor(init?: Partial<Doctor>) {
        super(init as Partial<User>);
        Object.assign(this, init);
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/doctor.ts